import * as React from 'react';

import { useQuery } from '@apollo/client';

import { useLocation, useParams } from 'js/lib/useRouter';
import { get as userGet } from 'js/lib/user';

import DegreeMyPageHeaderContext from 'bundles/composable-page-header-degree/contexts/DegreeMyPageHeaderContext';
import DegreeMyPageHeaderQuery from 'bundles/composable-page-header-degree/queries/DegreeMyPageHeaderQuery.graphql';
import type {
  DegreeMyPageHeaderQuery as DegreeMyPageHeaderQueryType,
  DegreeMyPageHeaderQueryVariables,
} from 'bundles/composable-page-header-degree/queries/__generated__/DegreeMyPageHeaderQuery';

const DegreePageHeaderBffProvider = ({ children }: { children: React.ReactNode }) => {
  const { programSlug } = useParams();
  const { query } = useLocation();

  const { id: userId } = userGet();

  // Extra logic to verify that the any type of query?.programSlug is actually a string we can use
  const isQueryAString = (inputQuery: typeof query): inputQuery is string => {
    return !!(inputQuery instanceof String);
  };
  const programSlugFromQuery = query?.programSlug;
  let verifiedProgramSlugFromQuery: string | undefined;
  if (isQueryAString(programSlugFromQuery)) {
    verifiedProgramSlugFromQuery = programSlugFromQuery;
  }

  const programSlugWithFallback = programSlug ?? verifiedProgramSlugFromQuery;

  const { data, error } = useQuery<DegreeMyPageHeaderQueryType, DegreeMyPageHeaderQueryVariables>(
    DegreeMyPageHeaderQuery,
    {
      variables: {
        degreeProgramSlug: programSlugWithFallback,
      },
      context: {
        clientName: 'gatewayGql',
      },
      errorPolicy: 'all',
      skip: !userId,
    }
  );

  return (
    <DegreeMyPageHeaderContext.Provider
      value={{
        myPageHeader: data?.PageHeader?.queryMyPageHeader,
        error,
      }}
    >
      {children}
    </DegreeMyPageHeaderContext.Provider>
  );
};

export default DegreePageHeaderBffProvider;
